import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import axios from "axios";

import Info from "../common/info";
import MenuGroupForm from "./menuGroupForm";
import { MenuGroupFormContainer } from "../../styled/setting";

const EditGroup = ({
  closeForm,
  toggleModal,
  menuGroup,
  setMenuGroup,
  openModal,
  closeModal,
  selectCompany,
  getMenuGroup,
  domain,
}) => {
  // 유효성 체크
  const validationCheck = () => {
    if (!menuGroup.name) {
      toast.error("상품명을 입력해주세요.");
      return false;
    }

    return true;
  };

  const handleSave = () => {
    if (!validationCheck()) return;

    openModal({
      type: "confirmation",
      title: "메뉴 그룹 수정",
      message: ["변경한 메뉴 그룹을 저장하시겠습니까?"],
      handleConfirm: handleEdit,
    });
  };

  const handleEdit = async () => {
    try {
      const url = "/erp/menuGroup/update";
      const body = {
        input: {
          id: menuGroup.id,
          name: menuGroup.name,
          menuPlatform: menuGroup.menuPlatform,
          cmpnyNo: selectCompany.value,
          productIds: (menuGroup?.products || []).map(({ id }) => Number(id)),
        },
      };

      const res = await axios.post(url, body);
      if (res.status === 200) {
        toast.success("메뉴 그룹이 수정되었습니다.");
        closeForm();
        await getMenuGroup();
      }
    } catch (error) {
      console.log(error);
    } finally {
      closeModal();
    }
  };

  return (
    <MenuGroupFormContainer>
      <Info
        message="메뉴 그룹 수정"
        actions={[
          { label: "취소", func: closeForm, key: "cancel" },
          { label: "저장", func: handleSave, key: "add" },
        ]}
      />
      <MenuGroupForm
        menuGroup={menuGroup}
        setMenuGroup={setMenuGroup}
        toggleModal={toggleModal}
        selectCompany={selectCompany}
        domain={domain}
      />
    </MenuGroupFormContainer>
  );
};

export default EditGroup;
